(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('tyClearFormOnInit', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                require: 'form',
                link: function (scope, element, attrs, ngFormCtrl) {
                    $timeout(function () {
                        ngFormCtrl.$$element.find("[ng-model], [data-ng-model], [type='text']")
                            .not(".ng-valid.ng-not-empty")
                            .toArray().forEach(el => {
                                el.value = "";
                            });
                        ngFormCtrl.$$element.find("[type='radio'][ng-model], [type='radio'][data-ng-model]")
                            .not(".ng-valid.ng-not-empty")
                            .toArray().forEach(el => {
                                el.checked = false;
                            });
                    });
                }
            };
        }]);
})(window.angular);